// import React, { useEffect } from 'react';
// import { Route, Navigate, useNavigate } from 'react-router-dom';
// import { jwtDecode } from "jwt-decode";
// import { useAuth } from './AuthProvider';

// function PrivateRoute({ children , role, ...rest }) {
//     const { isAuthenticated } = useAuth();

//     const token = localStorage.getItem('token');
//     let decodedToken = null;
//     if (token) decodedToken = jwtDecode(token); 
//     console.log(decodedToken);
//     const navigate = useNavigate();
//     console.log(isAuthenticated+"inside privayte");
    
//     useEffect(() => {
//         if (!isAuthenticated || !token || (decodedToken.exp*1000 < (new Date()).getTime())) {
//             localStorage.removeItem('token');
//             localStorage.removeItem('refreshToken');
//             localStorage.removeItem('examinerId');
//             localStorage.removeItem('studentId');
//             navigate('/login');
//         }
//     },[] );

//     if(token && role.some(role => decodedToken.roles.includes(role))){
//         console.log(children);
//         return children
//       }
//       return <Navigate to="/login" />
// }

// export default PrivateRoute;

import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";
import { useAuth } from './AuthProvider';

function PrivateRoute({ children, role }) {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [valid, setValid] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');

    if (!token) {
      navigate('/login');
      return;
    }

    try {
      const decodedToken = jwtDecode(token);

      // Check expiration
      if (decodedToken.exp * 1000 < Date.now()) {
        localStorage.clear();
        navigate('/login');
        return;
      }

      // Check role
      if (!role.some(r => decodedToken.roles.includes(r))) {
        navigate('/login');
        return;
      }

      setValid(true);

    } catch (err) {
      console.error('Invalid token:', err);
      localStorage.clear();
      navigate('/login');
    }

  }, [isAuthenticated, navigate, role]);

  return valid ? children : null;
}

export default PrivateRoute;
